// extracted by mini-css-extract-plugin
export default {"samovyvozContainer":"StoresRecievType_samovyvozContainer__4RjuJ","samovyvoz":"StoresRecievType_samovyvoz__SKUR9"};